import { NgTemplateOutlet } from '@angular/common'
import { ChangeDetectionStrategy, Component, TemplateRef, input } from '@angular/core'

@Component({
    selector: 'app-tb-board',
    templateUrl: './tb-board.component.html',
    styleUrls: ['./tb-board.component.sass'],
    imports: [NgTemplateOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TbBoardComponent {
    readonly columnTemplate = input.required<TemplateRef<any>>()
}
